<template>
  <div class="header_div">
    <div class="optSider">
      <el-icon size="20" @click="handleOpen" v-if="!side_Store.isCollapse"><Fold /></el-icon>
      <el-icon size="20" @click="handleClose" v-if="side_Store.isCollapse"><Expand /></el-icon>
    </div>
    <div class="locationShow" >
      <a href="/index">
<!--        <svg-icon iconClass="element-plus-logo" width="100"></svg-icon>-->
        <img :src="jh_Image"  width="100"/>
      </a>
    </div>
    <div class="userOpt">
<!--      <el-dropdown @command="handleCommand">-->
<!--        <svg-icon icon-class="language"></svg-icon>-->
<!--        <template #dropdown>-->
<!--          <el-dropdown-menu>-->
<!--            <el-dropdown-item command="chinese">中文</el-dropdown-item>-->
<!--            <el-dropdown-item command="english">English</el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </template>-->
<!--      </el-dropdown>-->

      <el-dropdown @command="handleCommand">
            <el-avatar
                :src="userLog_Image"
            />

        <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item >{{currentUsername}}</el-dropdown-item>
              <el-dropdown-item command="updatePassword" divided>修改密码</el-dropdown-item>
<!--              <el-dropdown-item command="about">关于</el-dropdown-item>-->
              <el-dropdown-item command="exit" >安全退出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
      </el-dropdown>
    </div>
  </div>


  <el-dialog v-model="dialogFormVisible" :title="dialogFormTitle">
    <el-form :model="dialogFormData" label-position="left">
      <el-form-item label="旧密码" :label-width="dialogFormLabelWidth" v-show="true">
        <el-input  v-model="dialogFormData.sourcePassword" autocomplete="off" />
      </el-form-item>
      <el-form-item label="新密码" :label-width="dialogFormLabelWidth">
        <el-input show-password type="password" v-model="dialogFormData.newPassword" autocomplete="off" placeholder="字母和数字组合,长度大于6位"/>
      </el-form-item>
      <el-form-item label="确认密码" :label-width="dialogFormLabelWidth">
        <el-input show-password type="password" v-model="dialogFormData.newPasswordTwice" autocomplete="off" placeholder="字母和数字组合,长度大于6位"/>
      </el-form-item>
    </el-form>
    <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="updatePasswordSubmit">
              更新密码
            </el-button>
          </span>
    </template>
  </el-dialog>
</template>

<script>
import {siderStore} from "@/stores/siderStore";
import {Expand, Fold} from "@element-plus/icons";
import userLog_Image from"@/assets/header/userLog.png"


import router from "@/router";
import {reactive, ref, toRaw} from "vue";
import {loginUserStore} from "@/stores/loginUserStore";
import callApi from "@/api/api";
import {ElMessage, ElMessageBox} from "element-plus";
import txlx_Image_three from "@/assets/xuanhao/3.jpeg";
import jh_Image from"@/assets/jh/img.png"





export default {
  name: "HeaderComponent",
  computed: {
    txlx_Image_three() {
      return txlx_Image_three
    }
  },
  components: {Expand, Fold},
  data(){
    return {
      jh_Image
    }
  },
  setup() {
    const side_Store = siderStore();
    function handleOpen(){
      side_Store.handleOpen()
    }

    function handleClose(){
      side_Store.handleClose()
    }

    function exit(){
      localStorage.removeItem("loginUserStore");
      router.push('/');
    }

    function updatePassword(){
      dialogFormVisible.value=true;
      dialogFormTitle.value="修改密码";
    }

    async function updatePasswordSubmit() {
      if(dialogFormData.newPassword !== dialogFormData.newPasswordTwice){
        ElMessage({
          type: 'warning',
          message: "两次密码不一致,请核对",
        })
        return
      }
      if(dialogFormData.newPassword === "Aa123456"){
        ElMessage({
          type: 'warning',
          message: "新密码不能是初始密码",
        })
        return
      }
      if (dialogFormData.newPassword.length <= 6) {
        ElMessage({
          type: 'warning',
          message: "密码长度必须大于6位",
        })
        return ;
      }
      if (!/[a-zA-Z]/.test(dialogFormData.newPassword) || !/[0-9]/.test(dialogFormData.newPassword)) {
        ElMessage({
          type: 'warning',
          message: "密码必须包含字母和数字组合",
        })
        return ;
      }
      let requestData = toRaw(dialogFormData);
      let data;
      data = await callApi('/infoaccountadmin/user/updateUserPassword', 'post', requestData);
      if (data) {
        ElMessage({
          type: 'success',
          message: data.data,
        })
        if(data.code == 200){
          dialogFormVisible.value = false
          setTimeout(function(){
            exit()
          },200)
        }
      }
    }

    function language(lang){
      lang = lang === 'chinese' ? 'zh' : 'en'
      localStorage.setItem('lang', lang)
      location.reload();
    }

    function handleCommand(command){
      switch (command) {
        case "updatePassword":
          //修改密码
          updatePassword();
          break
        case "about":
          //关于
          break
        case "exit":
          //退出
          exit();
          break
        case "chinese":
          language("chinese");
          break
        case "english":
          language("english");
          break
        default:
          //这里是没有找到对应的值处理
          break
      }
    }

    function checkHasDefaultPwd(){
      if(loginUserStore().sessionInfo.hasDefaultPwd === 1){
        ElMessageBox.confirm('为了账号安全,请修改初始密码,如不操作，系统5分钟自动关闭', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          updatePassword()
        }).catch(() => {
          // 用户取消操作
          exit();
        })
        const _this = this;
        setTimeout(() => {
          _this.exit();
        }, 5*60*1000); // 1000毫秒，即1分钟
      }
    }


    const dialogFormVisible = ref(false)
    const dialogFormTitle = ref("")
    const dialogFormLabelWidth = '80px'
    const currentUserId = ref(0)
    currentUserId.value = loginUserStore().sessionInfo.userId
    const currentUsername= ref(0)
    currentUsername.value = (loginUserStore().sessionInfo.realname!=null)?loginUserStore().sessionInfo.realname:loginUserStore().sessionInfo.username
    const dialogFormData = reactive({
      sourcePassword: '',
      newPassword: '',
      newPasswordTwice: '',
      userId: currentUserId.value
    })

    return {
      side_Store,
      handleOpen,
      handleClose,
      handleCommand,
      userLog_Image:userLog_Image,
      dialogFormVisible,
      dialogFormTitle,
      dialogFormLabelWidth,
      currentUserId,
      dialogFormData,
      updatePasswordSubmit,
      currentUsername,
      checkHasDefaultPwd,
      exit
    }
  },
  mounted() {
    const _this = this;
    _this.checkHasDefaultPwd();
  }
}
</script>

<style scoped>
.header_div{
  display: flex;
  border: 0px solid red;
  width: 100%;
  height: 50px;
  line-height: 50px;
}
.optSider{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 50px;
  font-weight: normal;
}
.locationShow{
  display: flex;
  justify-content: left;
  align-items: center;
  /*最后的30px留给加载图标*/
  /*
   100% - optSider.width - userOpt.width - 30px
  */
  width: calc(100% - 64px - 100px - 30px);
  height: 50px;
  font-weight: normal;
  #border: 1px solid red;
}
.userOpt{
  display: flex;
  justify-content: right;
  align-items: center;
  width: 100px;
  height: 50px;
  font-weight: normal;
  #border: 1px solid red;
}

</style>